import React from 'react';
import { Control, FieldPath, FieldValues } from 'react-hook-form';
import Checkbox, { CheckboxProps } from './Checkbox';
import { useFormField } from '../hooks/useFormField';

interface FormCheckboxProps<T extends FieldValues> extends Omit<CheckboxProps, 'name' | 'checked' | 'onChange' | 'error'> {
  name: FieldPath<T>;
  control: Control<T>;
}

function FormCheckbox<T extends FieldValues>({ 
  name, 
  control, 
  ...checkboxProps 
}: FormCheckboxProps<T>) {
  const { value, onChange, onBlur, error } = useFormField({ name, control, defaultValue: false });

  return (
    <Checkbox
      {...checkboxProps}
      name={name}
      checked={Boolean(value)}
      onChange={(e) => onChange(e.target.checked)}
      onBlur={onBlur}
      error={error}
    />
  );
}

export default FormCheckbox;